<template>
  <div v-if="title" class="hero">
    <div class="uk-cover-container">
      <div class="hero__content uk-container">
        <div style="z-index: 2">
          <h1 class="uk-heading-small uk-text-bold">
            Goldfish<br />{{ title }}
          </h1>
          <button class="uk-button uk-button-large button-custom">
            {{ $t("components.hero.label") }}
          </button>
          <p>
            {{ $t("components.hero.description") }}
          </p>
        </div>
        <div style="z-index: 1">
          <img :src="$api_url + image.url" uk-cover />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      label: "Brukerhåndbok",
    };
  },
  props: {
    title: String,
    image: Object,
  },
};
</script>

<style lang="scss">
.hero {
  background-color: rgba($color: #0b0b0b, $alpha: 1);
  .uk-cover-container {
    min-height: 500px;
  }

  img {
    max-height: 500px;
    object-fit: cover;
  }

  &__content {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 1rem;
    align-items: end;
    padding-top: 50px;
    padding-bottom: 0;
    color: #fff;

    .uk-heading-small {
      color: #fff;
    }

    p {
      font-size: 1.15rem;
    }

    @media (max-width: 700px) {
      grid-template-columns: 1fr;
    }
  }
  .button-custom {
    cursor: default;
    text-transform: capitalize;
    font-size: 1.4em;
    background-color: #a6dde8;
    color: #333;
  }
}
</style>
